class NodeUtility {
    /**
     * Get index of NodeList converted from index in Element
     * @param  {HTMLElement} targetElement Parent element of search target elements
     * @param  {number}      elementIndex  Index in element
     * @return {number}                    Index in NodeList
     */
    static getNodeListIndexByElementIndex(targetElement, elementIndex) {
        const nodeArray = Array.prototype.slice.call(targetElement.childNodes);
        const elementArray = nodeArray.filter((v) => {
            return v.nodeType === 1;
        });
        elementIndex = elementIndex < 0 ? elementArray.length + elementIndex : elementIndex;
        return nodeArray.indexOf(elementArray[elementIndex]);
    }
    static getAttributes(element) {
        const attributes = {};
        const domAttr = element.attributes;
        for (let i = 0; i < domAttr.length; i++) {
            const attrNode = domAttr.item(i);
            if (attrNode.name.startsWith("xmlns")) {
                continue;
            }
            const name = attrNode.namespaceURI ? attrNode.namespaceURI + "." + attrNode.localName : attrNode.localName;
            attributes[name] = attrNode.value;
        }
        return attributes;
    }
}
export default NodeUtility;



// WEBPACK FOOTER //
// ./src/Node/NodeUtility.ts